/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CreditorInstitution } from "./CreditorInstitution";
import * as t from "io-ts";

// required attributes
const CreditorInstitutionListR = t.interface({
  creditor_institutions: t.readonlyArray(
    CreditorInstitution,
    "array of CreditorInstitution"
  )
});

// optional attributes
const CreditorInstitutionListO = t.partial({});

export const CreditorInstitutionList = t.intersection(
  [CreditorInstitutionListR, CreditorInstitutionListO],
  "CreditorInstitutionList"
);

export type CreditorInstitutionList = t.TypeOf<typeof CreditorInstitutionList>;
